// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const AbarthTheme = props => {
	useThemeStylesheet(() => import("./abarth.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default AbarthTheme;
